<template>
  <ReportModuleTable
    title="Empresas cadastradas"
    subtitle="Clientes disponíveis para geração de relatórios de visita técnica."
    :columns="columns"
    :items="clients"
  >
    <template #empty>
      <ReportEmptyState
        title="Nenhuma empresa cadastrada"
        description="Cadastre empresas visitadas para gerar relatórios técnicos com dados e logo preenchidos automaticamente."
        :icon="PhBuildings"
      />
    </template>

    <template #cell-company="{ item }">
      <div class="flex items-center gap-3">
        <ReportVisitClientLogo :logo="item.logo_url" :alt="item.trade_name" />

        <div>
          <p class="font-semibold text-gray-800">
            {{ item.trade_name || item.corporate_name }}
          </p>

          <p class="text-xs text-gray-500">
            {{ item.corporate_name }}
          </p>
        </div>
      </div>
    </template>

    <template #cell-cnpj="{ item }">
      <span v-if="item.cnpj">{{ formatarCNPJ(item.cnpj) }}</span>
    </template>

    <template #cell-location="{ item }">
      <span>
        {{ item.city || "-" }}<span v-if="item.state">/{{ item.state }}</span>
      </span>
    </template>

    <template #cell-status="{ item }">
      <span
        class="inline-flex items-center rounded-full px-3 py-1 text-xs font-medium"
        :class="
          item.is_active
            ? 'bg-green-50 text-green-700 border border-green-100'
            : 'bg-gray-100 text-gray-500 border border-gray-200'
        "
      >
        {{ item.is_active ? "Ativa" : "Inativa" }}
      </span>
    </template>

    <template #actions="{ item }">
      <div class="flex items-center justify-center gap-2">
        <button
          type="button"
          title="Editar empresa"
          class="rounded-lg p-2 text-gray-400 transition hover:bg-yellow-50 hover:text-yellow-600"
          @click="$emit('edit', item)"
        >
          <PhNotePencil class="h-5 w-5" />
        </button>

        <button
          v-if="item.is_active"
          type="button"
          title="Inativar empresa"
          class="rounded-lg p-2 text-gray-400 transition hover:bg-red-50 hover:text-red-600"
          @click="$emit('disable', item)"
        >
          <PhTrash class="h-5 w-5" />
        </button>

        <button
          v-else
          type="button"
          title="Reativar empresa"
          class="rounded-lg p-2 text-gray-400 transition hover:bg-green-50 hover:text-green-700"
          @click="$emit('enable', item)"
        >
          <PhCheckCircle class="h-5 w-5" />
        </button>
      </div>
    </template>
  </ReportModuleTable>
</template>

<script setup>
import {
  PhBuildings,
  PhNotePencil,
  PhTrash,
  PhCheckCircle,
} from "@phosphor-icons/vue";
import ReportModuleTable from "../shared/ReportModuleTable.vue";
import ReportEmptyState from "../shared/ReportEmptyState.vue";
import ReportVisitClientLogo from "./ReportVisitClientLogo.vue";
import { formatarCNPJ } from "@/utils/reports/cnpj-mask";

defineProps({
  clients: {
    type: Array,
    default: () => [],
  },
});

defineEmits(["edit", "disable", "enable"]);

const columns = [
  {
    key: "company",
    label: "Empresa",
  },
  {
    key: "cnpj",
    label: "CNPJ",
  },
  {
    key: "responsible_name",
    label: "Responsável",
  },
  {
    key: "phone",
    label: "Telefone",
  },
  {
    key: "location",
    label: "Cidade/UF",
  },
  {
    key: "status",
    label: "Status",
    align: "center",
  },
];
</script>
